import { motion } from 'framer-motion';
import { useState } from 'react';
import { ToggleInputWrapper } from './styles';

export default function ToggleInput({
    onChange,
    defaultValue
}: {
    defaultValue?: boolean
    onChange: (isSelected: boolean) => void;
}) {
    const [isSelected, setSelected] = useState(defaultValue || false);

    return (
        <ToggleInputWrapper
            aria-checked={isSelected}
            onClick={() => {
                setSelected(e => {
                    onChange(!e)
                    return !e;
                });
            }}
            style={{ justifyContent: isSelected ? 'flex-end' : 'flex-start' }}
        >
            <motion.span
                layout
                transition={{ duration: 0.1, ease: 'easeInOut' }}
            ></motion.span>
        </ToggleInputWrapper>
    );
}
